import React from 'react'
import Vimeo from '@u-wave/react-vimeo';

import {connect} from "react-redux"
import moment from "moment"
import { listenToSession, unListenSession, addCommentToSession, setSessionNotification, deleteCommentFromSession } from '../../actions/comments'
import { deleteImage } from '../../actions/images'
import { orderBy } from 'lodash'
import './styles/SessionComments.scss'
import FileUpload from './FileUpload'
import PhotoImg from '../../images/icons/photo_black.svg'
import eventbus from '../../store/eventbus'
import pdfIcon from './images/file-pdf-regular.svg'

let eventBusVariable = null

// GLOBAL MEDIA UPLOAD
import { openCloseMediaUpload, setCurrentSessionInStore, setIsInternalUpload, setSessionName, setScopeAndSessionType } from '../../actions/media_upload'

@connect((store) => {
	return {
		User: store.User.User,
		modal: store.modal,
		media_upload: store.media_upload,
		gallery: store.gallery,
   }
})
class SessionComments extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			'text': '',
			'loading': false,
			'uploadImg': null
		}
		this.updateText = this.updateText.bind(this)
		this.addComment = this.addComment.bind(this)
		this.attachImage = this.attachImage.bind(this)
		this.deleteComment = this.deleteComment.bind(this)
		this.loadComments = this.loadComments.bind(this)
		this.loadTemplate = this.loadTemplate.bind(this)
		this.photoCommentTemplate = this.photoCommentTemplate.bind(this)
		this.documentCommentTemplate = this.documentCommentTemplate.bind(this)
		this.videoCommentTemplate = this.videoCommentTemplate.bind(this)
		this.setup = this.setup.bind(this);
	}

	componentDidUpdate(nextProps) {
		const { User } = this.props;

		if (User.token && User.name != nextProps.User.name) {
			this.setup();
		}
	}

	componentWillMount(){
		let { dispatch, User, session } = this.props;

		if (User.token && User.name != '') {
			dispatch({
				type: "INSERT_SESSION_USER",
				payload: {
					'user': User.uid,
					'sessionId': session._id
				}
			})
		}
	}

	deleteComment(id){
		let {dispatch, session} = this.props;
		if(confirm('Realy delete this comment?')){
			if(session.comments[id].img){
				deleteImage(session.comments[id].img)
			}
			dispatch(deleteCommentFromSession(id, session._id))
		}
	}

	componentDidMount(){
		let { User, type } = this.props;

		if (User.token && User.name != '') {
			this.setup();
		}

		// Eventbus from MediaUpload component
		eventBusVariable = eventbus.subscribe("writeGalleryIdInComment", (result)=>{
			// save comment
			console.log("Eventbus", result)
			console.log("EventbusType", type)
			if ((type === 'internal' && result.scope === type) || (type === undefined && result.scope === 'public')) {
				let commentObj = {
					text: `[[${result.id}]]`
				}
				this.saveComment(commentObj)
			}
		})
	}

	setup() {
		let { dispatch, session, User } = this.props;
		dispatch(listenToSession(session._id, User))
		dispatch(setSessionNotification(session._id, [User.uid], null,  0))

		dispatch({
			type: "INSERT_SESSION_USER",
			payload: {
				'user': User.uid,
				'sessionId': session._id
			}
		})
	}

	componentWillUnmount(){
		let { dispatch, session, User } = this.props;
		dispatch(setSessionNotification(session._id, [User.uid], null, 0))
		unListenSession(session._id)
		eventbus.clearSubscribtions("writeGalleryIdInComment")
	}

	saveComment(comment){
		let { dispatch, User, session, type } = this.props;
		comment.user = User.uid;
		comment.ts = Date.now();

		if (type !== undefined) {
			comment.type = type;
		}

		// notify other users
		let otherUsers = Object.keys(session.users).filter(userId => userId !== User.uid);
		if (type === undefined) {
			dispatch(setSessionNotification(session._id, otherUsers, comment))
		}
		return dispatch(addCommentToSession(session._id, comment))
	}

  	addComment(comment){
		if (this.state.text !== '') {
				this.saveComment(comment)
				.then(c => {
					this.updateText('')
				})
		}
	}

	attachImage(img){
		let comment = {text: '', img: img};
		this.saveComment(comment)
		this.setState({
			'uploadImg': img.orig
		})
		setTimeout(()=>{
			this.setState({
				'uploadImg': null
			})
		}, 10000)
	}

  	updateText(v){
		this.setState({
		text: v
		})
	}

	loadTemplate(comment) {
		const { gallery } = this.props;
		// console.log(gallery);
		if (comment.text.includes('[[') && comment.text.includes(']]')) {
			let text = comment.text.replace('[[', '');
			text = text.replace(']]', '');
			if (text !== 'undefined' && text !== undefined) {
				if (gallery.items.length) {
					let galIndex = gallery.items.findIndex((gal) => gal.id == text);
					if (galIndex > -1) {
						switch (gallery.items[galIndex].media) {
							case 'photo':
								return this.photoCommentTemplate(gallery.items[galIndex]);
								break;

							case 'document':
								return this.documentCommentTemplate(gallery.items[galIndex]);
								break;

							case 'video':
								if (gallery.items[galIndex].url !== undefined &&
									gallery.items[galIndex].url !== 'Uploading Video' &&
									gallery.items[galIndex].url !== 'Failed to upload Video'
								) {
									return this.videoCommentTemplate(gallery.items[galIndex]);
								}
								break;
						
							default:
								break;
						}
					}
				}
			}
		} 
		return comment.text.split('\n').map((t, i)=><p key={`comment${comment.id}_${i}`}>{t}</p>);
	}

	photoCommentTemplate(gal) {
		return <div className="thumb photo" key={gal.id}>
			<img src={gal.url}/>
		</div>
	}

	documentCommentTemplate(gal) {
		return <div className="thumb file" key={gal.id}>
			<a href={gal.url} target="_blank">
			<svg fill="#c11515"  aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-pdf" className="svg-inline--fa fa-file-pdf fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#c11515" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path></svg>
				<span>
					{gal.filename ? gal.filename : "File"}
					<small>PDF Document</small>
				</span>
			</a>
		</div>
	}

	videoCommentTemplate(gal) {
		return <div className="thumb video" key={gal.id}>
			<Vimeo
				responsive={true}
				video={gal.url.replace("/videos/", "")}
			/>
		</div>
	}
	
	loadComments(session, User, uploadImg, addComment) {
		const { type } = this.props;
		// console.log(uploadImg);
		
		return  orderBy(Object.values(session.comments),['ts'], ['desc'] ).map((comment) => {
			// console.log(type);
			if (comment.type === type) {
				// console.log(comment);
				return (
					<div key={comment.ts}
					className={"comment " + (comment.user.uid === User.uid && "own " +  (comment.img && "image"))}>
							<b className="quiet">{comment.user.name}</b><br />
							{comment.img ? 
								<img role="presentation" src={comment.img.orig === uploadImg? PhotoImg : comment.img.orig} /> :
								comment.text && this.loadTemplate(comment)
							}
							<div className="md-caption">
								{ moment(comment.ts).format('ddd Do of MMM YYYY')} - { moment(comment.ts).fromNow() }
								{/*<br /> 
								{ addComment === true ?  comment.user.uid === User.uid && <a className="link  " onClick={()=>{
									this.deleteComment(comment.id)
										}
									}>Delete</a>
								: ''} */} 
							</div>
					</div>
				)
			}
		});
	}

	// Session Media Upload
	toggleMediaUpload(bool){
		const { type } = this.props;

		if(bool){
			setCurrentSessionInStore(this.props.session)
			if(type == "internal"){
				setScopeAndSessionType({scope: "internal", sessionType: "comment", parent: this.props.parent, therapist: this.props.therapist})
			  } else {
				setScopeAndSessionType({scope: "public", sessionType: "comment", parent: this.props.parent, therapist: this.props.therapist})
			}
		}
		openCloseMediaUpload(bool)
	}

	render(){
		let {session , User} = this.props;
			let { text, loading, uploadImg } = this.state;
		let addComment = this.props.modal.data.addComment;

		return loading ? <div><p>Loading comments ...</p></div> :
			<div>
				{addComment === true ? 
					<div className="comments-inputs" ref={(div => {
						this.inputDiv = div
					})}>
						<textarea className="md-input" placeholder="Write a comment..." onChange={e => {
							this.updateText(e.target.value)
						}} value={text}></textarea>
						<button className="md-button" onClick={() => {
							this.addComment( {text: text})
						}}>Send</button>
						{/* <FileUpload name={`comment_${new Date().getTime()}`}
							path={`images/users/${User.uid}/comments/`}
							callback={this.attachImage} /> */}
						<button className="md-button" onClick={(e)=> this.toggleMediaUpload(true)}><svg width="25" aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus-square" className="svg-inline--fa fa-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg></button> 
					</div> : '' }
					<div>
						{ this.loadComments(session, User, uploadImg, addComment) }
						<br />
					</div>
			</div>
	}
}

SessionComments.defaultProps = {
  comments: {},
  session:{users:{}},
  updateScroll: 0,
  parent: false,
  therapist: true
}

export default SessionComments;



// WEBPACK FOOTER //
// ./src/components/ui/SessionComments.jsx